import React, { Component } from 'react';
// import './App.css';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
//import './style.css';
import NavMenu from './navmenu';
import Systems from "./SystemFunction";
import Banner from './banner';
import MoblieMenu from "./mobilemenu";
import TextSlider from './textslide';
import axios from 'axios';
import Swal from 'sweetalert2'
import moment from 'moment';
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      prettylist: [],
      access: null, // [2026-11-04] สิทธิ์ดูไลฟ์ตามยอดฝาก (ตั้งค่าในหลังบ้าน: ตั้งค่า Ulive)
      player: null, // { item, url, loading, playing, error, muted, portrait }
    }
    this.videoRef = React.createRef();
    this.playerBoxRef = React.createRef();

  }

  async componentDidMount() {
    this.link = document.createElement('link');
    this.link.rel = 'stylesheet';
    this.link.href = (process.env.PUBLIC_URL || '') + '/ulive.css'; // Path to your CSS
    document.head.appendChild(this.link);
    this.loadAccess();

    const res = await axios.post("https://api.upretty.live/public/pretty/list/explore", {
      page: 1,
    });
    console.log(res.data);
    this.setState({
      prettylist: res.data.rows
    });

  }

  _auth = () => { const t = localStorage.getItem('auth_token'); return t ? { headers: { Authorization: `Bearer ${t}` } } : {}; };
  loadAccess = async () => {
    try {
      const r = await instance.post('/api/v1/ulive/access', { System: Systems }, this._auth());
      if (r.data && r.data.status === 200) this.setState({ access: r.data });
    } catch (e) { }
  };
  // ข้อความเงื่อนไข เช่น "ฝาก 300 บาท ดูได้ 1 วัน"
  ruleText = () => ((this.state.access && this.state.access.rules) || []).map((r) => 'ฝาก ' + Number(r.minDeposit).toLocaleString('en-US') + ' บาท (ครั้งเดียว) ดูได้ ' + r.days + ' วัน').join('<br/>');
  showLocked = async () => {
    const a = this.state.access || {};
    if (!a.loggedIn) {
      const c = await Swal.fire({ title: 'เข้าสู่ระบบก่อนดูไลฟ์', html: this.ruleText(), icon: 'info', showCancelButton: true, confirmButtonText: 'เข้าสู่ระบบ', cancelButtonText: 'ปิด' });
      if (c.isConfirmed) window.location.href = '/login';
      return;
    }
    const c = await Swal.fire({ title: 'ฝากเงินเพื่อปลดล็อกไลฟ์', html: this.ruleText(), icon: 'info', showCancelButton: true, confirmButtonText: 'ไปฝากเงิน', cancelButtonText: 'ปิด' });
    if (c.isConfirmed) window.location.href = '/deposit';
  };
  // ---------- [2026-11-04] เปิดไลฟ์ในกรอบบนหน้าเว็บ (ไม่เปิดแท็บใหม่) ----------
  //   ลิงก์เป็น HLS (.m3u8 ของ AWS IVS): Safari/iPhone เล่นเองได้ · Chrome/Android ใช้ hls.js (โหลดจาก CDN ตอนกดดูครั้งแรก)
  _loadHls = () => {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (this._hlsP) return this._hlsP;
    this._hlsP = new Promise((resolve, reject) => {
      const sc = document.createElement('script');
      sc.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.17/dist/hls.min.js';
      sc.async = true;
      sc.onload = () => resolve(window.Hls);
      sc.onerror = () => { this._hlsP = null; reject(new Error('โหลดตัวเล่นวิดีโอไม่สำเร็จ')); };
      document.head.appendChild(sc);
    });
    return this._hlsP;
  };
  _siteLogo = () => {
    try {
      const l = localStorage.getItem('site_loader_logo'); if (l) return l;
      const c = JSON.parse(localStorage.getItem('mainSettingCache') || 'null');
      const d = c && (c.data || c);
      return (d && d.tblsetting && d.tblsetting[0] && d.tblsetting[0].imglogo) || '';
    } catch (e) { return ''; }
  };
  _destroyHls = () => { try { if (this.hls) { this.hls.destroy(); this.hls = null; } } catch (e) { } };
  startPlayer = async () => {
    const v = this.videoRef && this.videoRef.current;
    const url = this.state.player && this.state.player.url;
    if (!v || !url) return;
    this._destroyHls();
    this.setState((st) => ({ player: { ...st.player, loading: true, error: '', playing: false } }));
    try {
      // [2026-11-04] ใช้ hls.js ก่อนเสมอถ้าเบราว์เซอร์รองรับ (Chrome/Android บางรุ่นตอบว่าเล่น m3u8 เองได้ แต่เล่นจริงไม่ได้ -> "The element has no supported sources")
      //   ใช้ตัวเล่นในเครื่องเฉพาะเมื่อ hls.js ใช้ไม่ได้ (iPhone/iPad Safari)
      let Hls = null;
      try { Hls = await this._loadHls(); } catch (e) { Hls = null; }
      if (!(Hls && Hls.isSupported())) {
        if (!v.canPlayType('application/vnd.apple.mpegurl')) throw new Error('เบราว์เซอร์นี้เล่นไลฟ์ไม่ได้ ลองเปิดด้วย Chrome หรือ Safari');
        v.src = url;
      } else {
        const hls = new Hls({ lowLatencyMode: true, liveSyncDurationCount: 3, maxBufferLength: 20 });
        this.hls = hls;
        hls.on(Hls.Events.ERROR, (ev, data) => {
          if (!data || !data.fatal) return;
          if (data.type === Hls.ErrorTypes.NETWORK_ERROR && (!data.response || data.response.code !== 403)) { hls.startLoad(); return; }
          if (data.type === Hls.ErrorTypes.MEDIA_ERROR) { hls.recoverMediaError(); return; }
          this._destroyHls();
          this.setState((st) => ({ player: { ...st.player, loading: false, playing: false, error: 'ไลฟ์จบแล้ว หรือลิงก์หมดอายุ — กด "ลองใหม่"' } }));
        });
        hls.loadSource(url);
        hls.attachMedia(v);
      }
      v.muted = !!(this.state.player && this.state.player.muted);
      await v.play().catch(async (err) => {
        if (err && err.name === 'NotAllowedError') { v.muted = true; this.setState((st) => ({ player: { ...st.player, muted: true } })); await v.play(); return; }
        throw err;
      });
    } catch (e) {
      const m = String((e && e.message) || '');
      const msg = /supported source|NotSupported/i.test(m + (e && e.name)) ? 'ไลฟ์นี้เล่นไม่ได้ในตอนนี้ (อาจจบไลฟ์แล้ว) — กด "ลองใหม่"' : (m || 'เล่นไม่สำเร็จ');
      this.setState((st) => ({ player: { ...st.player, loading: false, playing: false, error: msg } }));
    }
  };
  stopPlayer = () => {
    const v = this.videoRef && this.videoRef.current;
    try { if (v) v.pause(); } catch (e) { }
    this._destroyHls(); // หยุดโหลดจริง (ไม่กินเน็ต) — กดเล่นใหม่จะต่อที่ไลฟ์ล่าสุด
    try { if (v) { v.removeAttribute('src'); v.load(); } } catch (e) { }
    this.setState((st) => ({ player: { ...st.player, playing: false, loading: false } }));
  };
  closePlayer = () => {
    this.stopPlayer();
    try { if (document.fullscreenElement) document.exitFullscreen(); } catch (e) { }
    this.setState({ player: null });
  };
  toggleMute = () => {
    const v = this.videoRef && this.videoRef.current; if (!v) return;
    v.muted = !v.muted;
    this.setState((st) => ({ player: { ...st.player, muted: v.muted } }));
  };
  fullScreen = () => {
    const box = this.playerBoxRef && this.playerBoxRef.current; const v = this.videoRef && this.videoRef.current;
    try {
      if (document.fullscreenElement) { document.exitFullscreen(); return; }
      if (box && box.requestFullscreen) box.requestFullscreen();
      else if (v && v.webkitEnterFullscreen) v.webkitEnterFullscreen(); // iPhone
    } catch (e) { }
  };
  componentWillUnmount() { this._destroyHls(); }
  // [2026-11-04] กลับเมนูหลัก: เปิดมาจากแท็บเดิม -> ปิดแท็บนี้กลับไปแท็บเดิม · ไม่งั้นไปหน้าสมาชิก (ล็อกอินแล้ว) หรือหน้าแรก
  goBack = () => {
    this.closePlayer && this.state.player && this.closePlayer();
    try { if (window.opener && !window.opener.closed) { window.opener.focus(); window.close(); return; } } catch (e) { }
    if (window.history.length > 1 && document.referrer && document.referrer.indexOf(window.location.host) !== -1) { window.history.back(); return; }
    window.location.href = localStorage.getItem('auth_token') ? '/home' : '/';
  };

  clickopen = async (id) => {
    const a = this.state.access;
    if (a && a.enabled && !a.allowed) { this.showLocked(); return; }
    const item = (this.state.prettylist || []).find((x) => x && x.livestream && x.livestream._id === id) || {};
    try {
      if (!id) throw new Error('missing stream id');
      this.setState({ player: { item, url: '', loading: true, error: '', playing: false, muted: false } });
      // ขอลิงก์ผ่านระบบเรา (เช็คสิทธิ์ตามยอดฝากก่อน)
      const pr = await instance.post('/api/v1/ulive/playback', { System: Systems, id: id }, this._auth());
      const pd = pr.data || {};
      if (pd.status === 401 || pd.status === 403) {
        this.setState({ player: null });
        if (pd.access) this.setState({ access: Object.assign({}, this.state.access, pd.access, { loggedIn: pd.status !== 401 }) });
        this.showLocked();
        return;
      }
      if (pd.status !== 200) throw new Error(pd.message || 'ยังไม่มีการไลฟ์สด');
      const data = pd.data || {};
      let href = data.playbackUrl || data.url;
      if (href && typeof href === 'object') href = href.url || href.playbackUrl || (href[0] && (href[0].url || href[0].playbackUrl));
      if (!href || typeof href !== 'string') throw new Error('ยังไม่มีการไลฟ์สด');
      this.setState((st) => ({ player: { ...(st.player || {}), url: href } }), () => this.startPlayer());
    } catch (err) {
      const msg = (err && err.response && err.response.data && err.response.data.message) || (err && err.message) || 'ยังไม่มีการไลฟ์สด หรือเซิร์ฟเวอร์ตอบกลับผิดพลาด';
      this.setState((st) => (st.player ? { player: { ...st.player, loading: false, error: msg } } : null));
    }
  };

  render() {
    const { prettylist, access } = this.state;
    const list = Array.isArray(prettylist) ? prettylist : [];
    const live = list.filter((it) => it && it.livestream && it.livestream.isLive);
    const offline = list.filter((it) => it && it.livestream && !it.livestream.isLive);
    const locked = !!(access && access.enabled && !access.allowed);
    const fmtTime = (it) => {
      const s = it.liveDateTimeStart ? moment(it.liveDateTimeStart).format('HH:mm') : '';
      const e = it.liveDateTimeEnd ? moment(it.liveDateTimeEnd).format('HH:mm') : '';
      return s && e ? s + ' - ' + e : s || e || '';
    };
    const card = (it, isLive, i) => (
      <button type="button" key={(it.livestream && it.livestream._id) || i} className={'ul-card' + (isLive ? ' is-live' : ' is-off')}
        onClick={() => (isLive ? this.clickopen(it.livestream && it.livestream._id) : Swal.fire({ title: it.displayName || 'ยังไม่เริ่มไลฟ์', text: 'ยังไม่เริ่มไลฟ์' + (fmtTime(it) ? ' · เวลาไลฟ์ ' + fmtTime(it) : ''), icon: 'info', confirmButtonText: 'ตกลง' }))} title={it.displayName || ''}>
        <div className="ul-img" style={{ backgroundImage: 'url("' + (it.profileImageUrl || '') + '")' }} />
        <div className="ul-shade" />
        <div className="ul-top">
          {isLive ? <span className="ul-badge live"><i />LIVE</span> : <span className="ul-badge off">ออฟไลน์</span>}
          <span className="ul-view">👁 {Number((it.livestream && it.livestream.viewerCount) || 0).toLocaleString('en-US')}</span>
        </div>
        <div className="ul-bottom">
          <div className="ul-name">{it.displayName || '-'}</div>
          {fmtTime(it) ? <div className="ul-time">🕒 {fmtTime(it)}</div> : null}
        </div>
        {isLive && locked ? <div className="ul-lock"><span>🔒</span><small>ฝากเพื่อปลดล็อก</small></div> : null}
        {isLive && !locked ? <div className="ul-play">▶</div> : null}
      </button>
    );
    return (
      <div className="ul-page">
        <style>{`
          .ul-page{min-height:100vh;background:radial-gradient(900px 400px at 50% -120px,rgba(196,151,77,.25),transparent 70%),#0b0b10;color:#fff;font-family:inherit;padding:18px 16px 60px;box-sizing:border-box}
          .ul-wrap{max-width:1180px;margin:0 auto}
          .ul-head{display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;margin-bottom:16px}
          .ul-title{display:flex;align-items:center;gap:12px}
          .ul-back{padding:8px 14px;border-radius:12px;border:1px solid rgba(246,215,128,.5);background:rgba(246,215,128,.12);color:#F6D780;font-weight:900;font-size:15px;cursor:pointer;white-space:nowrap}
          .ul-back:hover{background:rgba(246,215,128,.22)}
          .ul-title h1{margin:0;font-size:28px;font-weight:900;letter-spacing:.5px;background:linear-gradient(90deg,#F6D780,#c4974d);-webkit-background-clip:text;background-clip:text;color:transparent}
          .ul-title p{margin:2px 0 0;color:#a1a1aa;font-size:14px}
          .ul-dot{width:12px;height:12px;border-radius:50%;background:#ef4444;box-shadow:0 0 0 0 rgba(239,68,68,.7);animation:ulPulse 1.6s infinite}
          @keyframes ulPulse{0%{box-shadow:0 0 0 0 rgba(239,68,68,.7)}70%{box-shadow:0 0 0 10px rgba(239,68,68,0)}100%{box-shadow:0 0 0 0 rgba(239,68,68,0)}}
          .ul-chip{padding:8px 14px;border-radius:999px;font-size:14px;font-weight:700;border:1px solid}
          .ul-chip.ok{background:rgba(22,163,74,.15);border-color:rgba(22,163,74,.55);color:#bbf7d0}
          .ul-gate{display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;padding:16px 18px;border-radius:16px;background:linear-gradient(135deg,rgba(196,151,77,.22),rgba(196,151,77,.06));border:1px solid rgba(196,151,77,.55);margin-bottom:22px}
          .ul-gate h3{margin:0 0 6px;font-size:18px;color:#F6D780;font-weight:900}
          .ul-rules{display:flex;gap:8px;flex-wrap:wrap}
          .ul-rule{background:rgba(0,0,0,.35);border:1px solid rgba(246,215,128,.35);border-radius:10px;padding:6px 12px;font-size:14px}
          .ul-rule b{color:#F6D780}
          .ul-btn{padding:10px 22px;border-radius:12px;border:none;background:linear-gradient(180deg,#F6D780,#c4974d);color:#2b1d05;font-weight:900;font-size:15px;cursor:pointer;white-space:nowrap}
          .ul-sec{display:flex;align-items:center;gap:10px;margin:8px 0 12px;font-size:18px;font-weight:900}
          .ul-sec small{font-size:13px;color:#a1a1aa;font-weight:600}
          .ul-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:14px;margin-bottom:26px}
          .ul-card{position:relative;display:block;width:100%;aspect-ratio:3/4;border:none;padding:0;border-radius:16px;overflow:hidden;cursor:pointer;background:#18181b;box-shadow:0 8px 24px rgba(0,0,0,.35);transition:transform .2s ease,box-shadow .2s ease;text-align:left;color:#fff}
          .ul-card:hover{transform:translateY(-4px);box-shadow:0 14px 30px rgba(0,0,0,.5)}
          .ul-card.is-live{outline:2px solid rgba(239,68,68,.75);outline-offset:-2px}
          .ul-card.is-off .ul-img{filter:grayscale(.55) brightness(.75)}
          .ul-img{position:absolute;inset:0;background-size:cover;background-position:center;transition:transform .35s ease}
          .ul-card:hover .ul-img{transform:scale(1.05)}
          .ul-shade{position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,.45) 0%,rgba(0,0,0,0) 30%,rgba(0,0,0,0) 55%,rgba(0,0,0,.85) 100%)}
          .ul-top{position:absolute;top:10px;left:10px;right:10px;display:flex;justify-content:space-between;align-items:center}
          .ul-badge{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:900;padding:3px 9px;border-radius:8px;letter-spacing:.5px}
          .ul-badge.live{background:#ef4444}
          .ul-badge.live i{width:7px;height:7px;border-radius:50%;background:#fff;animation:ulBlink 1s infinite}
          @keyframes ulBlink{50%{opacity:.2}}
          .ul-badge.off{background:rgba(0,0,0,.55);color:#d4d4d8}
          .ul-view{font-size:12px;font-weight:800;background:rgba(0,0,0,.5);padding:3px 8px;border-radius:8px;color:#F6D780}
          .ul-bottom{position:absolute;left:12px;right:12px;bottom:12px}
          .ul-name{font-size:17px;font-weight:900;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#F6D780;text-shadow:0 2px 6px rgba(0,0,0,.6)}
          .ul-time{font-size:13px;color:#e4e4e7;margin-top:3px}
          .ul-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(.8);width:54px;height:54px;border-radius:50%;background:rgba(239,68,68,.9);display:flex;align-items:center;justify-content:center;font-size:20px;opacity:0;transition:all .2s ease}
          .ul-card:hover .ul-play{opacity:1;transform:translate(-50%,-50%) scale(1)}
          .ul-lock{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;background:rgba(0,0,0,.45);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px)}
          .ul-lock span{font-size:34px}
          .ul-lock small{font-size:13px;font-weight:800;color:#F6D780}
          .ul-empty{padding:28px;border-radius:16px;background:rgba(255,255,255,.04);border:1px dashed rgba(255,255,255,.15);text-align:center;color:#a1a1aa;margin-bottom:26px}
          .ul-modal{position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.82);display:flex;align-items:center;justify-content:center;padding:16px;backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px)}
          .ul-player{position:relative;width:min(960px,100%);aspect-ratio:16/9;max-height:86vh;background:#000;border-radius:18px;overflow:hidden;border:1px solid rgba(246,215,128,.45);box-shadow:0 20px 60px rgba(0,0,0,.6)}
          .ul-player.portrait{width:auto;height:min(86vh,820px);aspect-ratio:9/16;max-width:100%}
          .ul-player:fullscreen{width:100%;height:100%;max-height:none;border-radius:0;aspect-ratio:auto}
          .ul-video{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:#000}
          .ul-wm{position:absolute;left:14px;bottom:78px;width:clamp(70px,14%,130px);opacity:.85;pointer-events:none;filter:drop-shadow(0 2px 6px rgba(0,0,0,.6))}
          .ul-ptop{position:absolute;top:12px;left:12px;right:12px;display:flex;align-items:center;gap:8px}
          .ul-x{margin-left:auto;width:36px;height:36px;border-radius:50%;border:none;background:rgba(0,0,0,.55);color:#fff;font-size:16px;cursor:pointer}
          .ul-center{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;text-align:center;padding:20px}
          .ul-err{background:rgba(0,0,0,.6);color:#fde68a;font-weight:700}
          .ul-spin{width:46px;height:46px;border-radius:50%;border:4px solid rgba(255,255,255,.2);border-top-color:#F6D780;animation:ulSpin .8s linear infinite}
          @keyframes ulSpin{to{transform:rotate(360deg)}}
          .ul-ctrl{position:absolute;left:0;right:0;bottom:0;padding:12px 14px;display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;background:linear-gradient(180deg,transparent,rgba(0,0,0,.85))}
          .ul-pname{font-weight:900;color:#F6D780;font-size:16px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:45%}
          .ul-cbtns{display:flex;gap:8px;flex-wrap:wrap}
          .ul-cb{padding:8px 14px;border-radius:10px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.12);color:#fff;font-weight:800;font-size:14px;cursor:pointer}
          .ul-cb.play{background:linear-gradient(180deg,#F6D780,#c4974d);color:#2b1d05;border:none}
          .ul-cb.stop{background:#ef4444;border:none}
          .ul-cb:disabled{opacity:.5}
          @media (max-width:640px){
            .ul-page{padding:12px 10px 50px}
            .ul-title h1{font-size:22px}
            .ul-grid{grid-template-columns:repeat(2,1fr);gap:10px}
            .ul-name{font-size:14px}
            .ul-time{font-size:11px}
            .ul-gate{padding:12px 14px}
            .ul-btn{width:100%}
            .ul-modal{padding:0}
            .ul-player{border-radius:0;width:100%;max-height:100vh}
            .ul-player.portrait{height:100vh;width:100%;aspect-ratio:auto}
            .ul-cb{padding:7px 10px;font-size:13px}
            .ul-pname{max-width:100%}
          }
        `}</style>
        <div className="ul-wrap">
          <div className="ul-head">
            <div className="ul-title">
              <button type="button" className="ul-back" onClick={this.goBack} title="กลับเมนูหลัก">← กลับ</button>
              <span className="ul-dot" />
              <div>
                <h1>ULIVE</h1>
                <p>ไลฟ์สดตอนนี้ {live.length} ห้อง · ทั้งหมด {list.length} ห้อง</p>
              </div>
            </div>
            {access && access.enabled && access.allowed ? (
              <span className="ul-chip ok">✅ ดูได้ถึง {moment(access.expiresAt).format('DD/MM/YYYY HH:mm')}</span>
            ) : null}
          </div>

          {locked ? (
            <div className="ul-gate">
              <div>
                <h3>🔒 ฝากเงินเพื่อปลดล็อกการดูไลฟ์</h3>
                <div className="ul-rules">
                  {(access.rules || []).map((r) => (
                    <span className="ul-rule" key={r.id}>ฝาก <b>{Number(r.minDeposit).toLocaleString('en-US')}</b> ดูได้ <b>{r.days} วัน</b></span>
                  ))}
                </div>
              </div>
              <button type="button" className="ul-btn" onClick={() => { window.location.href = access.loggedIn ? '/deposit' : '/login'; }}>
                {access.loggedIn ? 'ไปฝากเงิน' : 'เข้าสู่ระบบ'}
              </button>
            </div>
          ) : null}

          <div className="ul-sec"><span className="ul-dot" /> กำลังไลฟ์ <small>{live.length ? 'กดเพื่อเข้าชม' : ''}</small></div>
          {live.length ? <div className="ul-grid">{live.map((it, i) => card(it, true, i))}</div>
            : <div className="ul-empty">ไม่มีรายการที่กำลังไลฟ์สดในขณะนี้</div>}

          {offline.length ? (
            <>
              <div className="ul-sec">📅 ตารางไลฟ์ <small>{offline.length} ห้อง</small></div>
              <div className="ul-grid">{offline.map((it, i) => card(it, false, i))}</div>
            </>
          ) : null}
        </div>

        {/* ตัวเล่นไลฟ์ในกรอบ */}
        {this.state.player ? (() => {
          const pl = this.state.player; const it = pl.item || {}; const logo = this._siteLogo();
          return (
            <div className="ul-modal" onClick={(e) => { if (e.target === e.currentTarget) this.closePlayer(); }}>
              <div className={'ul-player' + (pl.portrait ? ' portrait' : '')} ref={this.playerBoxRef}>
                <video ref={this.videoRef} className="ul-video" playsInline autoPlay
                  onPlaying={() => this.setState((st) => ({ player: st.player && { ...st.player, playing: true, loading: false, error: '' } }))}
                  onPause={() => this.setState((st) => ({ player: st.player && { ...st.player, playing: false } }))}
                  onWaiting={() => this.setState((st) => ({ player: st.player && { ...st.player, loading: true } }))}
                  onLoadedMetadata={(e) => { const v = e.currentTarget; const pt = v.videoHeight > v.videoWidth; this.setState((st) => ({ player: st.player && { ...st.player, portrait: pt } })); }} />
                {logo ? <img className="ul-wm" src={logo} alt="" /> : null}
                <div className="ul-ptop">
                  <span className="ul-badge live"><i />LIVE</span>
                  <span className="ul-view">👁 {Number((it.livestream && it.livestream.viewerCount) || 0).toLocaleString('en-US')}</span>
                  <button type="button" className="ul-x" onClick={this.closePlayer} aria-label="ปิด">✕</button>
                </div>
                {pl.loading && !pl.error ? <div className="ul-center"><div className="ul-spin" /></div> : null}
                {pl.error ? (
                  <div className="ul-center ul-err">
                    <div>{pl.error}</div>
                    <button type="button" className="ul-btn" onClick={() => this.clickopen(it.livestream && it.livestream._id)}>ลองใหม่</button>
                  </div>
                ) : null}
                <div className="ul-ctrl">
                  <div className="ul-pname">{it.displayName || ''}</div>
                  <div className="ul-cbtns">
                    {pl.playing
                      ? <button type="button" className="ul-cb stop" onClick={this.stopPlayer}>■ หยุด</button>
                      : <button type="button" className="ul-cb play" onClick={this.startPlayer} disabled={!pl.url}>▶ เล่น</button>}
                    <button type="button" className="ul-cb" onClick={this.toggleMute}>{pl.muted ? '🔇 เปิดเสียง' : '🔊 ปิดเสียง'}</button>
                    <button type="button" className="ul-cb" onClick={this.fullScreen}>⛶ เต็มจอ</button>
                  </div>
                </div>
              </div>
            </div>
          );
        })() : null}
      </div>
    );
  }
}
export default App;
